import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, PlusIcon, SearchIcon } from 'lucide-react';
import { AddLeadModal } from './AddLeadModal';
import { NotificationMenu } from './NotificationMenu';
export function TopBar() {
  const navigate = useNavigate();
  const [addOpen, setAddOpen] = useState(false);
  const [confirmation, setConfirmation] = useState<string | null>(null);
  useEffect(() => {
    if (!confirmation) return;
    const timer = window.setTimeout(() => setConfirmation(null), 4000);
    return () => window.clearTimeout(timer);
  }, [confirmation]);
  return <header className="relative flex items-center gap-4 border-b border-gray-200 bg-white px-4 py-2.5" data-id="element-706" data-mp="2c3leqqw0nbb8">
      <div className="relative w-full max-w-md" data-id="element-707" data-mp="39ipgygjso4fw">
        <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" aria-hidden="true" data-id="element-708" data-mp="39kjzxpbi9mhc" />
        <input type="search" placeholder="Search leads, phones, loans..." aria-label="Search leads, phones, loans" className="w-full rounded-lg border border-gray-200 bg-white py-2 pl-9 pr-14 text-[13px] text-ink placeholder:text-gray-400 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20" data-id="element-709" data-mp="24zg47i7zq21" />
        <kbd className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 rounded border border-gray-200 bg-gray-50 px-1.5 py-0.5 text-[10px] font-medium text-gray-500" data-id="element-710" data-mp="3thkbmjl28uhc">
          ⌘K
        </kbd>
      </div>

      <div className="ml-auto flex items-center gap-2" data-id="element-711" data-mp="35m7wemxauhun">
        <button type="button" onClick={() => setAddOpen(true)} className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-[13px] font-medium text-ink transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand/30" data-id="element-712" data-mp="35nsp0701zqpv">
          <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-713" data-mp="18rbpdjsc22ov" />
          Add lead
        </button>
        <NotificationMenu data-id="element-714" data-mp="12dfn8xicwaba" />
      </div>

      <AddLeadModal open={addOpen} onClose={() => setAddOpen(false)} onCreated={name => {
      setConfirmation(`${name} added to your leads`);
      navigate('/leads');
    }} data-id="element-715" data-mp="12ccxwu0omfxh" />

      <AnimatePresence data-id="element-716" data-mp="sgt54ghezxcy">
        {confirmation && <motion.div role="status" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} className="absolute right-4 top-full z-40 mt-2 inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-[12.5px] font-medium text-ink shadow-lg" data-id="element-717" data-mp="1q2qpkjfcucrj">
            <CheckCircle2Icon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-718" data-mp="1bc9ox2ajnqvp" />
            {confirmation}
          </motion.div>}
      </AnimatePresence>
    </header>;
}